import 'regenerator-runtime/runtime'
import WebFont from 'webfontloader';
import React from 'react';
import { render } from 'react-dom';
import Tooltip from 'shared/dist/components/atoms/Tooltip';
import Routes from './routes';
import './lib/icons';

WebFont.load({
  google: {
    families: ['Lato:400,400i,700']
  }
});

// even if fonts fail to load, add wf-active class
setTimeout(
  () => {
    document.documentElement.classList.add('wf-active');
  },
  5000
);

render(
  <div className="app-container">
    <Routes />
    <Tooltip />
  </div>
  ,
  document.getElementById('app-wrapper')
);
